import { render, staticRenderFns } from "./MaskTool1.vue?vue&type=template&id=8738f5fa&scoped=true&"
import script from "./MaskTool1.vue?vue&type=script&lang=js&"
export * from "./MaskTool1.vue?vue&type=script&lang=js&"
import style0 from "./MaskTool1.vue?vue&type=style&index=0&id=8738f5fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8738f5fa",
  null
  
)

export default component.exports